import { useFetchCustomFilter } from '@modules/queryBuilder/hooks';
import { alpha, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { WhereClausePreview } from '../WhereClausePreview';

interface CustomFilterInfoTooltipContentProps {
  filterID?: string;
  filterName: string;
}

export const CustomFilterInfoTooltipContent = ({
  filterID,
  filterName,
}: CustomFilterInfoTooltipContentProps) => {
  const [, { getWhereClauseForTheFilter, loading }] = useFetchCustomFilter();
  const [whereClause, setWhereClause] = useState(EmptyWhereClause);

  const getAndSetWhereClause = useCallback(async () => {
    const whereClause = await getWhereClauseForTheFilter(filterID);
    setWhereClause(whereClause ?? EmptyWhereClause);
  }, [filterID, getWhereClauseForTheFilter]);

  useEffect(() => {
    if (filterID) {
      getAndSetWhereClause();
    }
  }, [getAndSetWhereClause, filterID]);

  return (
    <Stack m={1}>
      <Typography variant="body2" pb={1}>
        {filterName}
      </Typography>
      <WhereClausePreview
        whereClause={whereClause}
        isLoading={loading}
        sxProps={{
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.8),
        }}
      />
    </Stack>
  );
};
